import { gql } from '@apollo/client'

export default gql(`
    mutation($resolutions: [UpdateResolutionsInput]!, $aspectRatioId: ID!) {
        batchUpdateResolutions(
            input: $resolutions 
            aspectRatioId: $aspectRatioId
            ) {
            width
            height
            id
          }
    }`
)
